import { API_URL } from "@/constants/envVariables";

import { buildAuthHeaders, getAuthCredentials } from "@/helpers/authHeaders";

export async function getOrgLogo(token: string): Promise<string> {
  const response = await fetch(`${API_URL}/organization/logo`, {
    method: "GET",
    credentials: getAuthCredentials(),
    headers: {
      "Content-Type": "application/json",
      ...buildAuthHeaders(token),
    },
  });

  if (!response.ok) {
    return "";
  }

  const responseBlob = await response.blob();
  if (responseBlob.size === 0 || !responseBlob.type.startsWith("image/")) {
    return "";
  }

  return URL.createObjectURL(responseBlob);
}
